import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import SEO from "../SEO";
import { Button } from "../ui/button";

const LINKS = [
  { to: "/features", label: "Features" },
  { to: "/pricing", label: "Pricing" },
  { to: "/agency-os", label: "Agency OS" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];

// Catch-all for unknown URLs. scripts/serve.js already answers these with a
// 404 status; this gives the visitor a real page and a way back.
export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-[#F4F6FB]" data-testid="not-found-page">
      <SEO
        title="Page Not Found | MagicBolt AI"
        description="This page does not exist. Head back to the MagicBolt AI home page, features or pricing."
        path="/404"
        noindex
      />
      <Navbar />

      <section className="relative overflow-hidden border-b border-[#E6E9F1] bg-white pt-36 pb-24">
        <div className="mb-blob mb-blob-orange mb-anim-a w-[360px] h-[360px] -top-24 right-0" />
        <div className="mb-blob mb-blob-blue mb-anim-b w-[300px] h-[300px] top-10 -left-20" />
        <div className="absolute inset-0 mb-grid-lines opacity-60" />
        <div className="relative mx-auto max-w-2xl px-6 text-center">
          <div className="text-7xl font-extrabold tracking-tighter text-[#FF6B00] md:text-8xl">404</div>
          <h1 className="mt-4 text-3xl font-bold tracking-tighter leading-tight text-[#0B1533] md:text-4xl">
            We couldn't find that page
          </h1>
          <p className="mt-4 text-base leading-relaxed text-[#475569] md:text-lg">
            The link may be old or mistyped. Here are the pages most people are looking for.
          </p>
          <div className="mt-8 flex justify-center">
            <Button
              size="lg"
              className="h-12 rounded-lg bg-[#FF6B00] px-7 text-base font-semibold text-white hover:-translate-y-0.5 hover:bg-[#FF8533] hover:shadow-[0_12px_28px_rgba(255,107,0,0.35)]"
              asChild
            >
              <Link to="/">
                Back to Home <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </Button>
          </div>
          <nav className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm font-semibold">
            {LINKS.map((l) => (
              <Link key={l.to} to={l.to} className="text-[#475569] hover:text-[#FF6B00]">
                {l.label}
              </Link>
            ))}
          </nav>
        </div>
      </section>

      <Footer />
    </div>
  );
}
